import { CBTableHeaderView } from "../CBTableHeaderView"
import { BSColor } from "./BSColor"

/**
 * RHTableHeaderView
 * Styles: Bootstrap <thead>
 */
export class RHTableHeaderView<DataType> extends CBTableHeaderView<DataType> {
    
    constructor(elementID: string, descriptors: any[] = []) {
        
        super(elementID, descriptors);
        
        (this as RHTableHeaderView<DataType>).configureWithObject({
            backgroundColor: BSColor.textWhite,
            style: {
                // // Change to 1px to match data rows
                // borderBottom: `1px solid ${BSColor.borderLight.stringValue}`,
                // // Prevent padding/border from adding to the width
                // boxSizing: "border-box"
            }
        })
        
    }
    
    override updateContentForButtonStates() {
        super.updateContentForButtonStates()
        
        this.cells.slice(1, -1).forEach(cell => {
            
            cell.configureWithObject({
                titleLabel: {
                    textColor: BSColor.dark,
                    style: {
                        fontWeight: "600",
                        fontSize: "0.875rem",
                        textTransform: "none",
                        verticalAlign: "bottom"
                    }
                },
                style: {
                    padding: "0.5rem 0.5rem",
                    borderBottom: `1px solid ${BSColor.borderLight.stringValue}`
                },
                colors: {
                    titleLabel: {
                        normal: BSColor.dark,
                        highlighted: BSColor.primary,
                        selected: BSColor.primary
                    }
                }
            })
            
        })
    }
}
